import script from "./RcIconTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcIconTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./RcIconTooltip.vue?vue&type=style&index=0&id=77067d1c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77067d1c"]])

export default __exports__